import { Component, Input, OnInit } from '@angular/core';
import { WorkProjectrevenue } from '../../_generated/work-rest-api';

@Component({
  selector: 'ax-project-projectrevenues',
  templateUrl: './ax-project-projectrevenues.component.html',
  styleUrls: ['./ax-project-projectrevenues.component.scss'],
})
export class AxProjectProjectrevenuesComponent implements OnInit {
  @Input() projectrevenues: WorkProjectrevenue[];
  @Input() isInternalView = false;
  public accordionStates: any = {};

  constructor() {
  }

  ngOnInit() {
  }
}
